module.exports = __webpack_public_path__ + "static/media/Avatars_Other-20.9d521cf0.png";